<br><br><br>

<div [dir]="language == 'ar' ? 'rtl' : 'ltr'" class="mx-3 mx-md-5 mb-5">
  <div *ngIf="isLoading" class="text-center my-5">
    <div class="spinner-border text-primary" role="status"></div>
  </div>

  <div *ngIf="!isLoading && article">
    <h1 class="fw-bold mb-3 text-center">{{ article.title }}</h1>

    <div class="text-center text-muted mb-4 small">
      <!-- <span class="me-3">
        <i class="bi bi-calendar-event me-1"></i>
        {{ article.creationDate | date: 'dd-MM-yyyy' }}
      </span> -->
      <!-- <span class="me-3">
        <i class="bi bi-eye me-1"></i>
        {{ article.views }} {{ 'views' | translate }}
      </span> -->
      <span>
        <i class="bi bi-tag me-1"></i>
        {{ article.category }}
      </span>
      <p class="fw-bold mb-3 text-center">{{ article.description }}</p>
    </div>

    <div class="mb-4 text-center">
      <img *ngIf="article.imageUrl" [src]="article.imageUrl" [alt]="article.title"
        class="img-fluid rounded shadow-sm w-75 article-detail-img">
      <div *ngIf="!article.imageUrl" class="p-5 text-muted border rounded bg-light d-inline-block">
        {{ 'no_image' | translate }}
      </div>
    </div>

    <div class="bg-white p-4 rounded shadow-sm">
      <div [innerHTML]="article.htmlContent" class="article-content"></div>
    </div>
  </div>

  <div *ngIf="!isLoading && !article" class="text-center my-5">
    <p>{{ 'no_article_found' | translate }}</p>
  </div>
</div>